import { Card } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../common/constants';
import UserList from './components/UserList';

const Users = () => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  const isTabletViewport = useMedia(`(min-width: ${BREAKPOINTS.tablet}px)`);

  return (
    <>
      {!isDesktopViewport && (
        <div className="d-flex justify-between align-center users-header-buttons">
          <div>
            <div className="page-header text-primary">Users</div>
            <div id="sub-header" />
          </div>
          <div className="d-flex justify-between align-center">
            <div id="add-button" />
            <div id="user-import-export-buttons" className="d-flex" />
          </div>
        </div>
      )}
      <div className="mobile-card-wrapper">
        <Card className="setup-module">
          <div className="header d-flex align-center justify-between mb-10">
            {isDesktopViewport && (
              <h1>
                Users
                <div id="sub-header" />
              </h1>
            )}
            <div
              className={clsx(
                'users-header-buttons d-flex align-center',
                isDesktopViewport ? 'width-percent-50' : 'width-percent-100',
              )}
            >
              {isTabletViewport && (
                <div
                  id="search-component"
                  className={clsx('width-percent-100')}
                />
              )}
              <div id="add-button" />
              <div id="user-import-export-buttons" className="d-flex" />
            </div>
          </div>
          {!isTabletViewport && (
            <div
              id="search-component"
              className={clsx(
                'mb-5 d-flex align-center justify-end',
                'width-percent-100',
              )}
            />
          )}
          <UserList />
        </Card>
      </div>
    </>
  );
};

export default Users;
